import { storage } from '@/services/firebase'
import { saveFile } from '@/services/storage/saveFile'
import { deleteFile } from '@/services/storage/deleteFile'

export const renameFile = async (oldName, newName, path) => {
    if (!oldName || !newName || oldName === newName) return
    const oldRef = storage()
        .ref(path)
        .child(oldName)
    const url = await oldRef.getDownloadURL()
    const response = await fetch(url)
    if (!response.ok) {
        throw new Error('File could not be renamed')
    }
    const blob = await response.blob()
    const file = new File([blob], newName, {
        type: blob.type || 'application/octet-stream',
    })
    await saveFile(file, path, newName)
    await deleteFile(oldName, path)
}
